import "./NewsletterBar.css";
import { useState } from "react";

import { Amplify } from "aws-amplify";
import outputs from "../amplify_outputs.json";
import { generateClient } from "aws-amplify/data";

Amplify.configure(outputs);

const client = generateClient();
const GOOGLE_SHEETS_WEBHOOK =
  "https://script.google.com/macros/s/AKfycbxoTOU-JB2-vu1JlXf_p6DX5hhUhhhhRiNcCU55yuC27X_DZCzEvH4ofJ7QNdC-Ou4/exec";

export default function NewsletterBar() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    const normalizedEmail = email.trim().toLowerCase();

    try {
      // ✅ 1. Check for duplicates in DynamoDB
      const existing = await client.models.NewsletterSignup.list({
        filter: { email: { eq: normalizedEmail } },
      });

      if (existing.data.length > 0) {
        setStatus("duplicate");
        return;
      }

      // ✅ 2. Save to DynamoDB
      await client.models.NewsletterSignup.create({
        email: normalizedEmail,
        createdAt: new Date().toISOString(),
      });

      // ✅ 3. Fire-and-forget to Google Sheets using no-cors
      await fetch(GOOGLE_SHEETS_WEBHOOK, {
        method: "POST",
        mode: "no-cors", // 👈 bypasses CORS enforcement
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: normalizedEmail }),
      });

      setStatus("success");
      setEmail("");
    } catch (err) {
      console.error("Newsletter signup failed:", err);
      setStatus("error");
    }
  };

  return (
    <div className="newsletter-bar">
      <h2>Stay Updated</h2>
      <p>Subscribe to our newsletter for the latest updates, features, and tips.</p>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit" disabled={status === "loading"}>
          {status === "loading" ? "Subscribing..." : "Subscribe"}
        </button>
      </form>

      {status === "success" && (
        <p className="success-message">You're subscribed! 🎉</p>
      )}
      {status === "duplicate" && (
        <p className="error-message">This email is already subscribed.</p>
      )}
      {status === "error" && (
        <p className="error-message">Something went wrong. Try again.</p>
      )}
    </div>
  );
}
